import axios from 'axios';

// ✅ On live server: backend runs via reverse proxy at /api (no port needed, HTTPS)
// ✅ On local: set REACT_APP_API_URL=http://localhost:5000/api in .env
const API_BASE = process.env.REACT_APP_API_URL || 'https://carrental.oriesolutions.co.in/api';
const BASE = process.env.REACT_APP_BASE_URL || 'https://carrental.oriesolutions.co.in';

export const API = axios.create({
  baseURL: API_BASE,
  withCredentials: true
});

export const BASE_URL = BASE;
